import { TimeControl, Color } from '../types';

export const formatTime = (ms: number): string => {
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
};

export const formatTimeControlLabel = (tc: TimeControl | null): string => {
  if (tc === null) return 'No limit';
  if (tc.increment === 0 || tc.incrementType === 'none') return `${tc.minutes} min`;
  const typeSuffix = tc.incrementType === 'fischer' ? 'Fischer' : 'Bronstein';
  return `${tc.minutes}+${tc.increment} ${typeSuffix}`;
};

export const applyIncrement = (tc: TimeControl, timeSpentMs: number): number => {
  if (tc.incrementType === 'none') return 0;
  const incrementMs = tc.increment * 1000;
  if (tc.incrementType === 'fischer') return incrementMs;
  if (tc.incrementType === 'bronstein') return Math.min(timeSpentMs, incrementMs);
  return 0;
};

export const initClocks = (tc: TimeControl | null): { whiteTimeMs: number; blackTimeMs: number } => {
  if (tc === null) return { whiteTimeMs: 0, blackTimeMs: 0 };
  const initialTimeMs = tc.minutes * 60 * 1000;
  return { whiteTimeMs: initialTimeMs, blackTimeMs: initialTimeMs };
};

export const serializeTimeToSnapshot = (
  whiteTimeMs: number, 
  blackTimeMs: number, 
  turnStartMs: number | null
) => ({
  whiteTimeMs: whiteTimeMs > 0 ? whiteTimeMs : undefined,
  blackTimeMs: blackTimeMs > 0 ? blackTimeMs : undefined,
  lastMoveTimestamp: turnStartMs ?? undefined,
});

export const restoreTimeFromSnapshot = (
  snapshot: { whiteTimeMs?: number; blackTimeMs?: number },
  tc: TimeControl | null
): { whiteTimeMs: number; blackTimeMs: number } => {
  const initialTimeMs = tc ? tc.minutes * 60 * 1000 : 0;
  return {
    whiteTimeMs: snapshot.whiteTimeMs ?? initialTimeMs,
    blackTimeMs: snapshot.blackTimeMs ?? initialTimeMs,
  };
};

export const validateTimeControl = (tc: unknown): boolean => {
  if (tc === null || tc === undefined) return true;
  if (typeof tc !== 'object') return false;
  const { minutes, increment, incrementType } = tc as Record<string, unknown>;
  return (
    typeof minutes === 'number' && minutes > 0 &&
    typeof increment === 'number' && increment >= 0 &&
    ['none', 'fischer', 'bronstein'].includes(incrementType as string)
  );
};

export const isValidCustomInput = (minutes: number, increment: number): boolean =>
  minutes >= 1 && minutes <= 180 && increment >= 0 && increment <= 60;

export const computeTimeoutWinner = (currentPlayer: Color): Color =>
  currentPlayer === 'white' ? 'black' : 'white';

export const canControlTurnBeforeTimerStart = (
  currentPlayer: Color,
  playerControlColor: Color | null
): boolean =>
  currentPlayer === 'white' && (playerControlColor === null || playerControlColor === 'white');